import { motion } from 'motion/react';
import type React from 'react';

interface PDFViewerSidebarProps {
  children: React.ReactNode;
}

export const PDFViewerSidebar = ({ children }: PDFViewerSidebarProps) => {
  return (
    <motion.div
      initial={{ x: '-100%' }}
      animate={{ x: 0 }}
      exit={{ x: '-100%' }}
      transition={{
        duration: 0.2,
        ease: 'easeInOut',
      }}
      className="absolute inset-y-0 left-0 z-20 w-64 border-r border-border bg-background h-full overflow-hidden"
    >
      {children}
    </motion.div>
  );
};

export default PDFViewerSidebar;
